import { render, staticRenderFns } from "./loader.html?vue&type=template&id=18860006&scoped=true&external"
import script from "./loader.js?vue&type=script&lang=js&external"
export * from "./loader.js?vue&type=script&lang=js&external"
import style0 from "./loader.scss?vue&type=style&index=0&id=18860006&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18860006",
  null
  
)

export default component.exports